import { useAuthFlow } from '@/shared/auth';

import { PRODUCTS } from './const';

export function useAvailableProducts() {
  const { roles } = useAuthFlow();

  if (roles.includes('admin') || roles.includes('owner'))
    return PRODUCTS;

  return PRODUCTS.filter(product => !product.prefix || roles.some(role => role.startsWith(product.prefix)));
}
